import SmoothScroll from 'smooth-scroll';

let smoothscroll = null;

if (!smoothscroll) {
	smoothscroll = new SmoothScroll('a[data-smooth-scroll]', {
		speedAsDuration: true,
		durationMin: 1000,
		durationMax: 1000
	});
}

export default smoothscroll;
